import { render } from "./tzzhd.vue?vue&type=template&id=67222540&scoped=true&ts=true"
import script from "./tzzhd.vue?vue&type=script&lang=ts"
export * from "./tzzhd.vue?vue&type=script&lang=ts"

import "./tzzhd.vue?vue&type=style&index=0&id=67222540&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67222540"]])

export default __exports__